import React, { Component, createRef } from "react";

import { Button, Card, CardBody, Col, Container, Label, Row } from "reactstrap";
import { Link, Redirect } from "react-router-dom";
import { withTranslation } from "react-i18next";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

class ClientRejectStock extends Component {
  constructor(props) {
    super(props);
    this.state = {
      validation: "",
    };
    this.filesharhe_ref = createRef();
    this.handleSubmit = this.handleSubmit.bind(this);
    this.onChangeValidation = this.onChangeValidation.bind(this);
  }

  handleSubmit(e) {
    e.preventDefault();

    const modifiedV = { ...this.state.validation };

    this.setState({ validation: modifiedV });
  }

  //for change tooltip display propery
  onChangeValidation(fieldName, value) {
    const modifiedV = { ...this.state.validation };
    if (value !== "") {
      modifiedV[fieldName] = true;
    } else {
      modifiedV[fieldName] = false;
    }
    this.setState({ validation: modifiedV });
  }

  render() {
    //meta title
    document.title = "grader flow";
    const { history } = this.props;
    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid={true}>
            <Breadcrumbs breadcrumbItem={this.props.t('Clients Reject Stock')} />
            <Row>
              <Col xl="12">
                <Card>
                  <CardBody>
                    <Formik
                      enableReinitialize={true}
                      initialValues={{
                        date: (this.state && this.state.date) || "",
                        inwardID: (this.state && this.state.inwardID) || "",
                        diamondID: (this.state && this.state.diamondID) || "",
                        partyCode:
                          (this.state && this.state.partyCode) || "",
                        hpht: (this.state && this.state.hpht) || "",
                        lpht: (this.state && this.state.lpht) || "",
                        real: (this.state && this.state.real) || "",
                        jiram: (this.state && this.state.jiram) || "",
                        weight: (this.state && this.state.weight) || "",
                        returnpieces:
                          (this.state && this.state.returnpieces) || "",
                        inwardDate: (this.state && this.state.inwardDate) || "",
                        graderNotes:
                          (this.state && this.state.graderNotes) || "",
                      }}
                      validationSchema={Yup.object().shape({
                        attachment: Yup.mixed()
                          .nullable()
                          .notRequired()
                          .test(
                            "FILE_SIZE",
                            "Uploaded file is too big.",
                            value =>
                              !value || (value && value.size <= FILE_SIZE)
                          )
                          .test(
                            "FILE_FORMAT",
                            "Uploaded file has unsupported format.",
                            value =>
                              !value ||
                              (value && SUPPORTED_FORMATS.includes(value.type))
                          ),
                        date: Yup.string().required("This Value is Required"),
                        inwardID: Yup.string().required(
                          "This Value is Required"
                        ),
                        diamondID: Yup.string().required(
                          "This Value is Required"
                        ),
                        partyCode: Yup.string().required(
                          "This Value is Required"
                        ),
                        hpht: Yup.string().required("This Value is Required"),
                        lpht: Yup.string().required("This Value is Required"),
                        real: Yup.string().required("This Value is Required"),
                        jiram: Yup.string().required("This Value is Required"),
                        weight: Yup.string().required("This Value is Required"),
                        returnpieces: Yup.string().required(
                          "This Value is Required"
                        ),
                        inwardDate: Yup.string().required(
                          "This Value is Required"
                        ),
                        graderNotes: Yup.string().required(
                          "This Value is Required"
                        ),
                      })}
                      onSubmit={values => {
                        JSON.stringify(values, null, 4);
                      }}
                    >
                      {({ errors, status, touched, values }) => (
                        <Form className="needs-validation">
                          <Row>
                            <div className="d-lg-flex d-block justify-content-between">
                              <div>
                                <h4 className="pb-3 text-black fw-bold">{this.props.t('Clients Reject Stock')}</h4>
                              </div>
                              <div className="mb-3 row">
                                <Label
                                  htmlFor="date"
                                  className="col-12 col-sm-2 col-lg-4"
                                >
                                  <h5 className="fs-5 fw-bold text-black">
                                    Date:
                                  </h5>
                                </Label>
                                <div className="col-12 col-sm-5 col-lg-8">
                                  <Field
                                    className={
                                      "border-0 fs-5" +
                                      (errors.date && touched.date
                                        ? " is-invalid"
                                        : "")
                                    }
                                    type="date"
                                    name="date"
                                    placeholder="JANGAD0000123"
                                  />
                                  <ErrorMessage
                                    name="date"
                                    component="div"
                                    className="invalid-feedback"
                                  />
                                </div>
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <Label
                                htmlFor="inwardID"
                                className="col-md-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">
                                  {this.props.t('Jangad No')}
                                </h5>
                              </Label>
                              <div className="col-md-10 col-12">
                                <Field
                                  className={
                                    "form-control fs-5" +
                                    (errors.inwardID && touched.inwardID
                                      ? " is-invalid"
                                      : "")
                                  }
                                  type="text"
                                  name="inwardID"
                                  placeholder="JANGAD0000123"
                                />
                                <ErrorMessage
                                  name="inwardID"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <Label
                                htmlFor="diamondID"
                                className="col-md-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">
                                  Diamond ID
                                </h5>
                              </Label>
                              <div className="col-md-10 col-12">
                                <Field
                                  className={
                                    "form-control fs-5" +
                                    (errors.diamondID && touched.diamondID
                                      ? " is-invalid"
                                      : "")
                                  }
                                  type="text"
                                  name="diamondID"
                                  placeholder="DIAMOND000123"
                                />
                                <ErrorMessage
                                  name="diamondID"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <Label
                                htmlFor="partyCode"
                                className="col-md-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">
                                  {this.props.t('Party Code')}
                                </h5>
                              </Label>
                              <div className="col-md-10 col-12">
                                <Field
                                  className={
                                    "form-control fs-5" +
                                    (errors.partyCode && touched.partyCode
                                      ? " is-invalid"
                                      : "")
                                  }
                                  type="text"
                                  name="partyCode"
                                  placeholder="COMPANY000123"
                                />
                                <ErrorMessage
                                  name="partyCode"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <Label
                                htmlFor="hpht"
                                className="col-md-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">HPHT</h5>
                              </Label>
                              <div className="col-md-10 col-12">
                                <Field
                                  className={
                                    "form-control fs-5" +
                                    (errors.hpht && touched.hpht
                                      ? " is-invalid"
                                      : "")
                                  }
                                  type="text"
                                  name="hpht"
                                  placeholder="12"
                                />
                                <ErrorMessage
                                  name="hpht"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>

                            <div className="mb-3 row">
                              <Label
                                htmlFor="lpht"
                                className="col-md-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">LPHT</h5>
                              </Label>
                              <div className="col-md-10 col-12">
                                <Field
                                  className={
                                    "form-control fs-5" +
                                    (errors.lpht && touched.lpht
                                      ? " is-invalid"
                                      : "")
                                  }
                                  type="text"
                                  name="lpht"
                                  placeholder="12"
                                />
                                <ErrorMessage
                                  name="lpht"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <Label
                                htmlFor="real"
                                className="col-md-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">REAL</h5>
                              </Label>
                              <div className="col-md-10 col-12">
                                <Field
                                  className={
                                    "form-control fs-5" +
                                    (errors.real && touched.real
                                      ? " is-invalid"
                                      : "")
                                  }
                                  type="text"
                                  name="real"
                                  placeholder="12"
                                />
                                <ErrorMessage
                                  name="real"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <Label
                                htmlFor="jiram"
                                className="col-md-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">
                                  JIRAM
                                </h5>
                              </Label>
                              <div className="col-md-10 col-12">
                                <Field
                                  className={
                                    "form-control fs-5" +
                                    (errors.jiram && touched.jiram
                                      ? " is-invalid"
                                      : "")
                                  }
                                  type="text"
                                  name="jiram"
                                  placeholder="12"
                                />
                                <ErrorMessage
                                  name="jiram"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>

                            <div className="mb-3 row">
                              <Label
                                htmlFor="weight"
                                className="col-md-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">
                                  Weight
                                </h5>
                              </Label>
                              <div className="col-md-10 col-12">
                                <Field
                                  className={
                                    "form-control fs-5" +
                                    (errors.weight && touched.weight
                                      ? " is-invalid"
                                      : "")
                                  }
                                  type="text"
                                  name="weight"
                                  placeholder="20.25 CT"
                                />
                                <ErrorMessage
                                  name="weight"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <Label
                                htmlFor="returnpieces"
                                className="col-md-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">
                                  Total Return Pieces
                                </h5>
                              </Label>
                              <div className="col-md-10 col-12">
                                <Field
                                  className={
                                    "form-control fs-5" +
                                    (errors.returnpieces && touched.returnpieces
                                      ? " is-invalid"
                                      : "")
                                  }
                                  type="text"
                                  name="returnpieces"
                                  placeholder="12"
                                />
                                <ErrorMessage
                                  name="returnpieces"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <Label
                                htmlFor="inwardDate"
                                className="col-md-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">
                                  Inward Date
                                </h5>
                              </Label>
                              <div className="col-md-10 col-12">
                                <Field
                                  className={
                                    "form-control fs-5" +
                                    (errors.inwardDate && touched.inwardDate
                                      ? " is-invalid"
                                      : "")
                                  }
                                  type="text"
                                  name="inwardDate"
                                  placeholder="26/01/2022"
                                />
                                <ErrorMessage
                                  name="inwardDate"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <Label
                                htmlFor="graderNotes"
                                className="col-md-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">
                                  {this.props.t('Grader Notes')}
                                </h5>
                              </Label>
                              <div className="col-md-10">
                                <Field
                                  className={
                                    "form-control fs-5" +
                                    (errors.graderNotes && touched.graderNotes
                                      ? " is-invalid"
                                      : "")
                                  }
                                  type="text"
                                  name="graderNotes"
                                  as="textarea"
                                  rows="5"
                                  placeholder="Please Take of HPHT First Priority"
                                />
                                <ErrorMessage
                                  name="graderNotes"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>
                            <div className="col-md-12 text-center text-md-end mt-4">
                              <Button
                                color="white"
                                className="fs-4 border-0 text-primary me-0 me-md-5 fw-bold"
                                type="submit"
                              >
                                Accept
                              </Button>
                              <Button color="primary" className="fs-4 px-5">
                                Reject
                              </Button>
                            </div>
                          </Row>
                        </Form>
                      )}
                    </Formik>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}
export default withTranslation()(ClientRejectStock);
